import type { Sample } from './sample.interface';
import type { SampleGroup } from './sample-group.interface';

export interface cv_SampleSubtype {
    C_SampleSubtype_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    Sample: Sample[];
    SampleGroup: SampleGroup[];
    SampleSubtype: string;
    SortOrder: number | null;
    Version: number;
}
